import { CACHE_KEYS } from "@api/constants/cacheKeys";
import { ICommonServiceProps } from "@api/types/globalService.types";
import { useQuery } from "@tanstack/react-query";
import { getAllSubsegmentAPI, getSingleSubsegmentAPI } from "./subsegment.api";
import useGlobalDebounceHandler from "../useGlobalDebounceHandler";
import { useState } from "react";

const useAllSubsegmentService = ({
  page = "1",
  per_page = "15",
  enableQuery = true,
  cacheKeys = [],
  filters,
}: ICommonServiceProps) => {
  const [searchSubsegmentQuery, setSearchSubsegmentQuery] =
    useState<string>("");

  const { debouncedQuery } = useGlobalDebounceHandler(searchSubsegmentQuery);
  const allSubsegmentService = useQuery({
    queryKey: [...CACHE_KEYS.SUBSEGMENTS, page, per_page, ...cacheKeys],
    queryFn: () =>
      getAllSubsegmentAPI({
        searchParams: {
          "filter[name]": debouncedQuery,
          page,
          per_page,
          ...filters,
          include: "segment",
        },
      }),
    enabled: enableQuery,
  });

  return {
    states: { searchSubsegmentQuery, setSearchSubsegmentQuery },
    services: { allSubsegmentService },
  };
};

const useSingleSubsegmentService = ({
  singleSubsegmentId,
  enableQuery = true,
}: {
  singleSubsegmentId: string;
  enableQuery?: boolean;
}) => {
  return useQuery({
    queryKey: [...CACHE_KEYS.SUBSEGMENTS, singleSubsegmentId],
    queryFn: () => getSingleSubsegmentAPI(singleSubsegmentId),
    enabled: !!singleSubsegmentId && enableQuery,
  });
};

export { useAllSubsegmentService, useSingleSubsegmentService };
